// Configuracao centralizada de timings de animacao.
//
// ⚠️ SINCRONIA BACKEND: valores aqui devem casar com constantes no
// backend Go (internal/application/match_service.go):
//
//   HAND_TOTAL_PAUSE_MS   ←→  DefaultDealWarmup
//   TRICK_TOTAL_PAUSE_MS  ←→  DefaultTrickCloseWarmup
//
// O backend usa esses valores pra pausar bot/turn-timer durante a anim,
// garantindo que nenhum snap LIVE muda enquanto o overlay esta rodando.
// Mudar aqui = mudar la = redeploy backend.

export const ANIM = {
  /** Pausa ANTES do cinematic comecar — tempo pro user ver a 4a carta
   * atacada parada na mesa antes de iniciar o recolhimento. */
  TRICK_VIEW_DELAY_MS: 800,
  HAND_VIEW_DELAY_MS: 800,

  /** Anim de coleta no fim de cada vaza (4 cartas → centro). */
  TRICK_COLLECT_MS: 1500,

  /** Anim de coleta no fim de mao (4 cartas + vira → centro). */
  HAND_COLLECT_MS: 1500,

  /** Feature flag: desliga toda cinematografia D sem deletar codigo.
   * Util pra rollback rapido se algo bugar. */
  ENABLED: true,
} as const;

/** Tempo total que backend deve pausar bot/timer:
 * view delay + collect anim. Mudar aqui = mudar
 * DefaultTrickCloseWarmup / DefaultDealWarmup no backend. */
export const TRICK_TOTAL_PAUSE_MS = ANIM.TRICK_VIEW_DELAY_MS + ANIM.TRICK_COLLECT_MS;
export const HAND_TOTAL_PAUSE_MS = ANIM.HAND_VIEW_DELAY_MS + ANIM.HAND_COLLECT_MS;
